import React, { useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import TabBox from '../organisms/TabBox';
import List from '../organisms/List';
import ProviderListed from '../molecules/ProviderListed';
import AddItem from '../molecules/AddItem';
import Empty from '../atoms/Empty';
import { clearObj } from '../../lib/utils';
import { display } from '../../data/display';
// import styles from '../../styles/pages/Venue.module.scss';
import { Venue } from '../../graphql/types';
import router from 'next/router';
import { addVenueServiceProvider } from '../../lib/apis/venue';
import Button from '../atoms/Button';

interface VenueProvidersProps {
  data: any[];
  access?: boolean;
  apply: (id: string) => void;
  setLayer: (el: any) => void;
  serviceProviderPickHandler?: (data: any) => void;
  serviceProviderRemoveHandler?: (data: any) => void;
  serviceProviders?: any[];
}

const VenueProviders = (props: VenueProvidersProps) => {
  const type = 'service';
  const { t } = useTranslation(['common', type]);
  const [tab, setTab] = useState('catering');
  const { data, setLayer, access, apply, serviceProviders } = props;
  const planData = display.venue.platinum as any;

  /*
   * Service Provider
   */

  // Spaces data by tab
  const currProviders = planData.services ? data || [] : [];

  const currProvidersFiltered = access
    ? currProviders
    : currProviders.filter(
        (el: any) => (el.categories || []).indexOf(tab) > -1
      );

  // Services tabs
  const categories = Array.from(
    new Set([].concat(...data.map((item) => item.categories)))
  );
  const currTabs = access
    ? []
    : categories.map((key: string) => {
        const translationKey = key.toLowerCase().replace(/-/g, '_');

        return {
          id: key,
          label: t(`${type}:categories:${translationKey}`),
        };
      });

  const handleProviderClick = (data: any) => {
    router.push(`/service-provider/${data.country}/${data.city}/${data.slug}`);
  };

  const handleServiceProviderPick = (data: any) => {
    props.serviceProviderPickHandler?.(data);
    setLayer(null);
  };

  const handleServiceProviderRemove = (data: any) => {
    setLayer({
      auto: true,
      large: true,
      children: (
        <>
          <h3>{t('common:confirm-remove')}</h3>
          <Button
            dark
            medium
            full
            label={t('common:cta-confirm-remove')}
            onClick={() => {
              props.serviceProviderRemoveHandler?.(data);
              setLayer(null);
            }}
          />
        </>
      ),
    });
  };

  const handleServiceProviderCreate = () => {
    const queryObj = {
      ref: router.query?.slug,
    };
    router.push({
      pathname: `/promote-your-business/create/${type}`,
      query: {
        ...Object.fromEntries(
          Object.entries(queryObj).filter(([_, v]) => v !== undefined)
        ),
      },
    });
  };

  const availableToPickServiceProviders =
    serviceProviders
      ?.map((sp) => sp.service_provider)
      ?.filter(Boolean)
      ?.filter((sp) => !currProvidersFiltered.find((el) => el.id === sp.id)) ||
    [];

  return (
    <>
      <Row>
        <Col xs={8}>
          <TabBox
            mobileSlide
            full
            onChange={(id) => {
              setTab(id);
            }}
            title={t('common:service-providers')}
            tabs={currTabs}
          >
            {!!access && (
              <AddItem
                label={t(`${type}:add`)}
                href="/promote-your-business"
                onClick={() => handleServiceProviderCreate()}
              />
            )}

            {!!currProvidersFiltered.length ? (
              <List maxItems={3}>
                {currProvidersFiltered.map((el: any, i: number) => (
                  <ProviderListed
                    key={i}
                    data={el}
                    small={true}
                    onClick={handleProviderClick}
                    onRemove={
                      props.serviceProviderRemoveHandler
                        ? handleServiceProviderRemove
                        : undefined
                    }
                  />
                ))}
              </List>
            ) : (
              <Empty label={t(`${type}:empty`)} />
            )}
          </TabBox>
        </Col>
      </Row>
      <br />
      <br />
      <br />
    </>
  );
};

export default VenueProviders;
